import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useState } from "react";
import { requestTakeStudentAttendanceInGroupReservation } from "services/resources/library/aboutLibraryResources";
import { ACTION_TYPES } from "../constants";

const useTakeStudentsAttendance = ({
    students: {
        studentList,
        setStudentList,
        selectedStudents,
        setSelectedStudents
    },
    addActionTypeToListActions,
    setResolveType,
    loadingRequest
}) => {
    //#region Hooks
    const dialogShowTakeStudentsAttendanceConfirmation = useShowDialogAlert();
    //#endregion
    //#region States
    const [studentReservationDetailIdsToTakeAttendance, setStudentReservationDetailIdsToTakeAttendance] = useState([]);
    //#endregion
    //#region Functions
    const takeStudentAttendance = () => {
        setResolveType(ACTION_TYPES.TAKE_ATTENDANCE);
        // Ocultando modal de confirmación
        dialogShowTakeStudentsAttendanceConfirmation.set(false);
        // Marcando asistencia de estudiantes seleccionados
        setStudentReservationDetailIdsToTakeAttendance(
            studentList
            .filter(currentStudent => selectedStudents.some(({ id }) => currentStudent.id === id))
            .map(({ reservationDetailId }) => reservationDetailId));
        // Dando estado de por marcar asistencia a estudiante(s) de la lista
        setStudentList(studentList.map(currentStudent => {
            if (selectedStudents.some(({ id }) => currentStudent.id === id)) 
                return {
                    ...currentStudent,
                    forTakeAttendance: true
                };
            return { ...currentStudent };
        }));
        // Limpiando estudiantes seleccionados
        setSelectedStudents([]);
        addActionTypeToListActions(ACTION_TYPES.TAKE_ATTENDANCE);
    }
    const openTakeStudentAttendanceDialog = async () => {
        dialogShowTakeStudentsAttendanceConfirmation.set(true);
    }
    const doRequestTakeStudentAttendance = async () => {
        // Realizando petición de marcado de asistencia de estudiantes
        loadingRequest.show("Marcando asistencia...");
        const success = await requestTakeStudentAttendanceInGroupReservation({
            reservationDetailIds: studentReservationDetailIdsToTakeAttendance
        });
        loadingRequest.hide();
        // Gestionando errores
        if (!success) 
            throw new Error(true);
    }
    //#endregion
    return {
        fns: {
            takeStudentAttendance,
            openTakeStudentAttendanceDialog,
            doRequestTakeStudentAttendance
        },
        dialogs: {
            dialogShowTakeStudentsAttendanceConfirmation
        }
    };
}	
    
export default useTakeStudentsAttendance;